var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white border border-gray-200 rounded-lg p-4 sm:p-6" },
    [
      _c("div", { staticClass: "block sm:hidden" }, [
        _c("div", { staticClass: "flex items-center justify-between mb-4" }, [
          _c("div", { staticClass: "flex items-center space-x-3" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden",
              },
              [
                _vm.profile.avatar
                  ? _c("img", {
                      staticClass: "w-full h-full object-cover rounded-full",
                      attrs: {
                        src: _vm.profile.avatar,
                        alt: `${_vm.profile.name} avatar`,
                      },
                      on: { error: _vm.onAvatarError },
                    })
                  : _c(
                      "svg",
                      {
                        staticClass: "w-6 h-6 text-gray-400",
                        attrs: { fill: "currentColor", viewBox: "0 0 20 20" },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                            "clip-rule": "evenodd",
                          },
                        }),
                      ]
                    ),
              ]
            ),
            _c("div", { staticClass: "min-w-0" }, [
              _c("div", { staticClass: "flex items-center space-x-2" }, [
                _c(
                  "h3",
                  {
                    staticClass:
                      "text-base font-semibold text-gray-900 truncate",
                  },
                  [_vm._v(_vm._s(_vm.profile.name))]
                ),
                _c(
                  "button",
                  {
                    class: [
                      "p-1 rounded-full transition-colors flex-shrink-0",
                      _vm.profile.favorited
                        ? "text-red-500"
                        : "text-gray-400 hover:text-red-400",
                    ],
                    on: { click: _vm.toggleFavorite },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-4 h-4",
                        attrs: {
                          fill: _vm.profile.favorited ? "currentColor" : "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _c("p", { staticClass: "text-xs text-gray-500 truncate" }, [
                _vm._v(_vm._s(_vm.profile.title)),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "flex items-center space-x-2 flex-shrink-0" },
            [
              _c(
                "button",
                {
                  staticClass:
                    "px-3 py-1.5 bg-gray-100 text-gray-700 rounded-md text-xs hover:bg-gray-200 transition-colors",
                  on: { click: _vm.chatClicked },
                },
                [_vm._v(" Chat ")]
              ),
              _c(
                "button",
                {
                  staticClass: "p-1.5 transition-colors",
                  on: { click: _vm.toggleBookmark },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "w-4 h-4",
                      attrs: {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z",
                          stroke: "#D97706",
                          fill: _vm.profile.bookmarked ? "#D97706" : "none",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex items-center justify-between mb-3" }, [
          _c("div", { staticClass: "flex items-center space-x-2" }, [
            _c(
              "div",
              { staticClass: "flex" },
              _vm._l(5, function (star) {
                return _c(
                  "svg",
                  {
                    key: star,
                    class: [
                      "w-3 h-3",
                      star <= _vm.profile.rating
                        ? "text-yellow-400"
                        : "text-gray-300",
                    ],
                    attrs: { fill: "currentColor", viewBox: "0 0 20 20" },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z",
                      },
                    }),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                staticClass: "px-2 py-0.5 text-xs font-medium rounded-md",
                class: _vm.matchPercentageChipClass,
                style: _vm.matchPercentageChipStyle,
              },
              [_vm._v(" " + _vm._s(_vm.profile.matchPercentage) + "% Match ")]
            ),
          ]),
          _c("div", { staticClass: "text-base font-semibold text-gray-900" }, [
            _vm._v(" " + _vm._s(_vm.profile.hourlyRate) + " "),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "hidden sm:block" }, [
        _c("div", { staticClass: "flex items-start justify-between mb-4" }, [
          _c("div", { staticClass: "flex items-start space-x-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden",
              },
              [
                _vm.profile.avatar
                  ? _c("img", {
                      staticClass: "w-full h-full object-cover rounded-full",
                      attrs: {
                        src: _vm.profile.avatar,
                        alt: `${_vm.profile.name} avatar`,
                      },
                      on: { error: _vm.onAvatarError },
                    })
                  : _c(
                      "svg",
                      {
                        staticClass: "w-8 h-8 text-gray-400",
                        attrs: { fill: "currentColor", viewBox: "0 0 20 20" },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                            "clip-rule": "evenodd",
                          },
                        }),
                      ]
                    ),
              ]
            ),
            _c("div", [
              _c("div", { staticClass: "flex items-center space-x-3 mb-1" }, [
                _c(
                  "h3",
                  { staticClass: "text-lg font-semibold text-gray-900" },
                  [_vm._v(_vm._s(_vm.profile.name))]
                ),
                _c("span", { staticClass: "text-sm text-gray-500" }, [
                  _vm._v(_vm._s(_vm.profile.title)),
                ]),
                _c(
                  "button",
                  {
                    class: [
                      "p-1 rounded-full transition-colors",
                      _vm.profile.favorited
                        ? "text-red-500"
                        : "text-gray-400 hover:text-red-400",
                    ],
                    on: { click: _vm.toggleFavorite },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-5 h-5",
                        attrs: {
                          fill: _vm.profile.favorited ? "currentColor" : "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "flex items-center space-x-4 mb-2" }, [
                _c("div", { staticClass: "flex items-center space-x-1" }, [
                  _c("span", { staticClass: "text-sm font-medium" }, [
                    _vm._v("Rating:"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    _vm._l(5, function (star) {
                      return _c(
                        "svg",
                        {
                          key: star,
                          class: [
                            "w-4 h-4",
                            star <= _vm.profile.rating
                              ? "text-yellow-400"
                              : "text-gray-300",
                          ],
                          attrs: { fill: "currentColor", viewBox: "0 0 20 20" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z",
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "px-2 py-1 text-sm font-medium rounded-md",
                    class: _vm.matchPercentageChipClass,
                    style: _vm.matchPercentageChipStyle,
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.profile.matchPercentage) + "% Match "
                    ),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "text-lg font-semibold text-gray-900 mb-3" },
                [_vm._v(" " + _vm._s(_vm.profile.hourlyRate) + " ")]
              ),
            ]),
          ]),
          _c("div", { staticClass: "flex items-center space-x-3" }, [
            _c(
              "button",
              {
                staticClass:
                  "px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors",
                on: { click: _vm.chatClicked },
              },
              [_vm._v(" Chat ")]
            ),
            _c(
              "button",
              {
                staticClass: "p-2 transition-colors",
                on: { click: _vm.toggleBookmark },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "w-6 h-6",
                    attrs: {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z",
                        stroke: "#D97706",
                        fill: _vm.profile.bookmarked ? "#D97706" : "none",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm.profile.credentials && _vm.profile.credentials.length > 0
        ? _c("div", { staticClass: "mb-3 sm:mb-4" }, [
            _c(
              "h4",
              {
                staticClass:
                  "text-xs sm:text-sm font-medium text-gray-700 mb-2",
              },
              [_vm._v("Credentials:")]
            ),
            _c(
              "div",
              { staticClass: "flex flex-wrap gap-1.5 sm:gap-2" },
              _vm._l(_vm.profile.credentials, function (credential, index) {
                return _c(
                  "span",
                  {
                    key: credential,
                    staticClass: "px-2 py-1 text-xs rounded-md",
                    class: _vm.getRandomChipColor("credential", index),
                    staticStyle: { "background-color": "#1447e6" },
                  },
                  [_vm._v(" " + _vm._s(credential) + " ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm.profile.certifications && _vm.profile.certifications.length > 0
        ? _c("div", { staticClass: "mb-3 sm:mb-4" }, [
            _c(
              "h4",
              {
                staticClass:
                  "text-xs sm:text-sm font-medium text-gray-700 mb-2",
              },
              [_vm._v("Certifications:")]
            ),
            _c(
              "div",
              { staticClass: "flex flex-wrap gap-1.5 sm:gap-2" },
              _vm._l(
                _vm.profile.certifications,
                function (certification, index) {
                  return _c(
                    "span",
                    {
                      key: certification,
                      staticClass: "px-2 py-1 text-xs rounded-md",
                      class: _vm.getRandomChipColor("certification", index),
                      staticStyle: { "background-color": "#3b82f6" },
                    },
                    [_vm._v(" " + _vm._s(certification) + " ")]
                  )
                }
              ),
              0
            ),
          ])
        : _vm._e(),
      _vm.profile.skills && _vm.profile.skills.length > 0
        ? _c("div", { staticClass: "mb-3 sm:mb-4" }, [
            _c(
              "h4",
              {
                staticClass:
                  "text-xs sm:text-sm font-medium text-gray-700 mb-2",
              },
              [_vm._v("Skills:")]
            ),
            _c(
              "div",
              { staticClass: "flex flex-wrap gap-1.5 sm:gap-2" },
              _vm._l(_vm.profile.skills, function (skill, index) {
                return _c(
                  "span",
                  {
                    key: skill,
                    staticClass: "px-2 py-1 text-xs rounded-md",
                    class: _vm.getRandomChipColor("skill", index),
                    staticStyle: { "background-color": "#60a5fa" },
                  },
                  [_vm._v(" " + _vm._s(skill) + " ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm.profile.softSkills && _vm.profile.softSkills.length > 0
        ? _c("div", { staticClass: "mb-3 sm:mb-4" }, [
            _c(
              "h4",
              {
                staticClass:
                  "text-xs sm:text-sm font-medium text-gray-700 mb-2",
              },
              [_vm._v("Soft Skills:")]
            ),
            _c(
              "div",
              { staticClass: "flex flex-wrap gap-1.5 sm:gap-2" },
              _vm._l(_vm.profile.softSkills, function (softSkill, index) {
                return _c(
                  "span",
                  {
                    key: softSkill,
                    staticClass: "px-2 py-1 text-xs rounded-md",
                    class: _vm.getRandomChipColor("softSkill", index),
                    staticStyle: { "background-color": "#bfdbfe" },
                  },
                  [_vm._v(" " + _vm._s(softSkill) + " ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col sm:flex-row sm:items-center sm:justify-start flex-wrap gap-x-4 sm:gap-x-6 gap-y-2 text-xs sm:text-sm text-gray-600",
        },
        [
          _c(
            "div",
            {
              staticClass: "flex items-center space-x-1.5 sm:space-x-2 min-w-0",
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "w-3 h-3 sm:w-4 sm:h-4 text-blue-500 flex-shrink-0",
                  attrs: {
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129",
                    },
                  }),
                ]
              ),
              _c("span", { staticClass: "truncate" }, [
                _vm._v(_vm._s(_vm.profile.languages.join(", "))),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "flex items-center space-x-1.5 sm:space-x-2 min-w-0",
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "w-3 h-3 sm:w-4 sm:h-4 text-gray-400 flex-shrink-0",
                  attrs: {
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z",
                    },
                  }),
                ]
              ),
              _c("span", { staticClass: "whitespace-nowrap" }, [
                _vm._v(_vm._s(_vm.profile.distance)),
              ]),
            ]
          ),
          _vm.profile.hasVehicle
            ? _c(
                "div",
                {
                  staticClass:
                    "flex items-center space-x-1.5 sm:space-x-2 min-w-0",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "w-3 h-3 sm:w-4 sm:h-4 text-gray-400 flex-shrink-0",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M14 16H9m10 0h3v-3.15a1 1 0 00-.84-.99L16 11l-2.7-3.6a1 1 0 00-.8-.4H5.24a2 2 0 00-1.8 1.1l-.8 1.63A6 6 0 002 12.42V16h2",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "6.5", cy: "16.5", r: "2.5" },
                      }),
                      _c("circle", {
                        attrs: { cx: "16.5", cy: "16.5", r: "2.5" },
                      }),
                    ]
                  ),
                  _c("span", { staticClass: "whitespace-nowrap" }, [
                    _vm._v("Has vehicle"),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "flex items-center space-x-1.5 sm:space-x-2 min-w-0",
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "w-3 h-3 sm:w-4 sm:h-4 text-gray-400 flex-shrink-0",
                  attrs: {
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
                    },
                  }),
                ]
              ),
              _c("span", { staticClass: "whitespace-nowrap" }, [
                _vm._v(_vm._s(_vm.profile.availableHours) + " unbooked hours"),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "flex items-center space-x-1.5 sm:space-x-2 min-w-0",
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "w-3 h-3 sm:w-4 sm:h-4 text-gray-400 flex-shrink-0",
                  attrs: {
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
                    },
                  }),
                ]
              ),
              _c("span", { staticClass: "whitespace-nowrap" }, [
                _vm._v(
                  "Worked with client " +
                    _vm._s(_vm.profile.clientWorkCount) +
                    " times"
                ),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }